const PAYOUTS_TABLE_HEADERS = [
  {
    name: 'Type',
    column: 'type'
  },
  {
    name: 'Beneficiary address',
    column: 'address'
  },
  {
    name: 'Amount',
    column: 'amount_currency'
  },
  {
    name: 'Reference',
    column: 'reference'
  },
  {
    name: 'Date',
    column: 'created_at',
    filter: 'date'
  },
  {
    name: 'Status',
    column: 'status'
  }
];

const PAYOUT_STATUSES = [
  {
    label: 'All Payouts',
    value: ''
  },
  {
    label: 'Pending',
    value: 'PENDING'
  },
  {
    label: 'Successful',
    value: 'SUCCESSFUL'
  },
  {
    label: 'Failed',
    value: 'FAILED'
  }
];
export { PAYOUT_STATUSES, PAYOUTS_TABLE_HEADERS };
